<template>
  <div id="app">
    <!--路由出口-->
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    window.onload = function() {
      console.log(window.sessionStorage["ISlogin"]);
      if (!window.sessionStorage["ISlogin"]) {
        // 关闭浏览器
        window.sessionStorage.removeItem("openId");
      } else {
        // 刷新
      }
    };
    window.onunload = function() {
      window.sessionStorage["ISlogin"] = true;
    };
    window.onbeforeunload = function() {
      window.sessionStorage["ISlogin"] = true;
    };
  }
};
</script>

<style lang="less"></style>
